import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { User } from '@linktivity/link-icons';
import { Dropdown, message } from '@linktivity/link-ui';
import { LOGIN_PATH } from '@link/admin/constants';
import { getEmail, logout } from '@link/admin/services';

import styles from './header.module.css';

const EMAIL_TOAST_DURATION = 10;

const UserView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const email = getEmail();

  const accountButton = useMemo(
    () => (
      <button
        type="button"
        className={styles.account}
        onClick={() => setOpenMenu(visible => !visible)}
      >
        <User className={styles.accountIcon} />
        <span className={styles.accountText}>{t('common.account')}</span>
      </button>
    ),
    [t]
  );

  const handleClose = useCallback(() => {
    setOpenMenu(false);
  }, []);

  const handleEmailShow = useCallback(() => {
    message.info(email, EMAIL_TOAST_DURATION);
  }, [email]);

  const handleLogout = useCallback(async () => {
    await logout();
    navigate(LOGIN_PATH, { replace: true });
  }, [navigate]);

  return (
    <Dropdown
      target={accountButton}
      visible={openMenu}
      sameWidth={false}
      placement="bottom-end"
      onClose={handleClose}
    >
      <Dropdown.Menu className={styles.menu}>
        <Dropdown.Item>
          <button
            type="button"
            className={styles.menuButton}
            onClick={handleEmailShow}
          >
            <span className={styles.menuEmail} title={email}>
              {email}
            </span>
          </button>
        </Dropdown.Item>

        <Dropdown.Item>
          <button
            type="button"
            className={styles.menuButton}
            onClick={handleLogout}
          >
            {t('common.logout')}
          </button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserView;
